import { Grid } from '@material-ui/core';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';

import { LOCATION_STATE_COMPARATORS } from 'containers/WorkflowEditor/components/Rules/Condition/constants';

import { SharedConditionProps } from '../../types';
import { ComparatorSelect } from '../components/ComparatorSelect';
import { InputField } from '../InputField';
import messages from './messages';

export const LocationState: FC<SharedConditionProps> = props => {
  const intl = useIntl();

  const isList = props.condition.extra?.comparator === 'in';

  return (
    <>
      <ComparatorSelect
        {...props}
        allowedComparators={LOCATION_STATE_COMPARATORS}
      />
      <Grid item xs={6}>
        <InputField
          {...props}
          labelTooltip={intl.formatMessage(messages.locationStateHint)}
          placeholder={intl.formatMessage(
            isList
              ? messages.locationStateListPlaceholder
              : messages.locationStatePlaceholder,
          )}
        />
      </Grid>
    </>
  );
};
